const validate = (values) => {
  const attrs = values || {};
  const errors = {};

  if (!attrs.materia || !attrs.materia.value) {
    errors.materia = 'Debe seleccionar una materia';
  }

  return errors;
};

export default validate;
